import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

interface ComingSoonBannerProps {
  countryName: string | null;
}

const ComingSoonBanner: React.FC<ComingSoonBannerProps> = ({ countryName }) => {
  const { t } = useTranslation();

  return (
    <div
      role="alert"
      aria-live="polite"
      style={{
        background: 'linear-gradient(90deg, #0284c7 0%, #38bdf8 100%)',
        color: '#fff',
        padding: '10px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
        fontSize: '0.875rem',
        lineHeight: 1.5,
        zIndex: 1040,
        boxShadow: '0 2px 8px rgba(2, 132, 199, 0.3)',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10, flex: 1 }}>
        {/* Clock icon */}
        <span style={{ fontSize: '1.1rem', flexShrink: 0, marginTop: 1 }}>⏳</span>
        <span>
          <strong>
            {t('geo.coming_soon_title', { defaultValue: 'Coming Soon!' })}
          </strong>
          {' — '}
          {t('geo.coming_soon_banner_body', {
            country: countryName ?? t('geo.your_region', { defaultValue: 'your region' }),
            defaultValue:
              'You can create an account from {{country}}, but you cannot perform operations yet.',
          })}
          {' '}
          <Link to="/global-availability" style={{ color: '#fff', textDecoration: 'underline' }}>
            View global availability
          </Link>
        </span>
      </div>
    </div>
  );
};

export default ComingSoonBanner;
